import React, { useEffect, useState, useCallback, useRef } from "react";
import { useParams } from "react-router";
import Carousel from "react-bootstrap/Carousel";
import { Container, Row, Col } from "react-bootstrap";
import Filter from "../../components/Filter";
import notify from "../../components/UI/toast";
import { LoaderSmall } from "../../components/Loader";
import UIInfiniteScroll from "../../components/UI/InfiniteScroll/InfiniteScroll";
import CardProduct from "../../components/CardProduct";
import Categories from "../../components/FeaturedCategories";
import ProductsCarousel from "../../components/FeaturedProducts";
import Title from "../../components/Title";
import ImageBreak from "../../assets/404-banner.png";
import { useUserData } from "../../hooks/UserContext";
import { useNavigate } from "react-router";
import { clientesApi, configApi } from "../OrderResumePag/_services/api";

import {
  FeaturedCategoriesBrands,
  CotainerProduct,
  Banner,
} from "./styles";

import {
  toggleCheckBrand,
  selectBrands,
  selectOrder,
  selectRangeSlide,
  setBorderPrices,
  fetchCategory,
  clearCheckBrand,
  clearCheckCategories,
  setRangeSlide,
  resetFilters,
  selectCategories,
} from "../../Redux/filterSlice";

import { useDispatch, useSelector } from "react-redux";
import { useBannerTracking } from "../../hooks/useBannerTracking";
import { trackViewItemListMarketplace, trackSelectItemMarketplace, trackAddToWishlistMarketplace } from "../../utils/gtm";

export default function Product() {
  const [products, setProducts] = useState([]);
  const [banners, setBanners] = useState([]);
  const [data] = useState([]);
  const [loading, setLoading] = useState(true);
  const limit = 50;
  const [newPage, setNewPage] = useState(0);
  const [acceptNextPage, setAcceptNextPage] = useState(false);
  const brands = useSelector(selectBrands);
  const order = useSelector(selectOrder);
  const categories = useSelector(selectCategories);
  const rangeSlide = useSelector(selectRangeSlide);
  const [count, setCount] = useState(0);
  const [brandsFilter, setBrandsFilter] = useState([])
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [lastId, setLastId] = useState("");
  const [featuredCategories] = useState([]);
  const [featuredProducts] = useState([]);
  const [hasSetPriceRange, setHasSetPriceRange] = useState(false);
  const selectedCategoryLabel = categories.find((c) => c.check)?.label;
  const [wishlist, setWishlist] = useState([]);
  const firstBannerSent = useRef(false);
  const channel = process.env.REACT_APP_DEFAULT_CHANNEL;
  
  const { handleBannerView, handleBannerClick, userInteraction, setUserInteraction } = useBannerTracking(
    banners,
    channel,
    firstBannerSent
  );

  const { id } = useParams();

  const disp = useDispatch();

  const jwt = useUserData();
  const dataUser = jwt.userData?.data;

  const cpf = dataUser?.cpf;

  const navigate = useNavigate();

  const [filtersReset, setFiltersReset] = useState(false);

  useEffect(() => {
    disp(resetFilters());
    disp(fetchCategory({ id, newPage: 0, limit, cpf }));
  }, [id, disp, cpf]);

  useEffect(() => {
    disp(clearCheckBrand());
    disp(clearCheckCategories());
    localStorage.removeItem("orderFilter");
    setNewPage(0);
    setProducts([]);
    setCount(0);
    setFiltersReset(false);
    setTimeout(() => setFiltersReset(true), 0);
    setHasSetPriceRange(false);
  }, [id]);

  function onClickBrand(idBrand) {
    for (let i in brands) {
      if (idBrand === brands[i].id) {
        disp(
          toggleCheckBrand({
            id: idBrand,
          })
        );
        break;
      }
    }

    const brandsFilterArray = [];
    for (let i in brands) {
      if (brands[i].check === true) {
        brandsFilterArray.push(brands[i].id);
      }
    }
    setBrandsFilter(() => brandsFilterArray.join(','));
  }

  function onClickApplyFilter() {
    setNewPage(0);
    setHasSetPriceRange(true);
    setAcceptNextPage(false);
    setProducts([]);
    setCount(count + 1);
  }

  function onClickClearFilter() {
    navigate(`/loja/category/${id}`);
    window.location.reload();
  }

  async function fetchMore() {
    setNewPage((prev) => prev + 1);
  }

  function showFeaturedCategories() {
    return featuredCategories && featuredCategories.length > 0;
  }

  function showFeaturedProducts() {
    return (
      featuredProducts &&
      featuredProducts.hasOwnProperty("products") &&
      featuredProducts["products"].length > 0
    );
  }

  function onImageError(e) {
    e.target.src = ImageBreak;
  }

  async function apiWishlist() {
    if (!dataUser?.cpf) {
      console.warn("CPF não encontrado no dataUser, retornando array vazio para wishlist");
      return [];
    }
    
    try {
      const response = await clientesApi.get(
        `/customer/${dataUser.cpf}/wishlist`,
      );
      return response.data.data;
    } catch (error) {
      console.error("Erro ao buscar wishlist:", error);
      return [];
    }
  }

  async function getBanner() {
    try {
      const response = await configApi.get(
        `/banners/actives/categoria/${id}`
      );
      return response.data;
    } catch (err) {
      notify("Erro ao carregar home", "error");
    }
  }

  useEffect(() => {
  if (!filtersReset) return;

  const fetchData = async () => {
    if (lastId !== id) setLoading(true);
      setLoadingProducts(true);

      if (typeof cpf !== "undefined") {
        const wishlistData = await apiWishlist();
        setWishlist(wishlistData);

        disp(fetchCategory({ id, newPage, limit, cpf }))
          .unwrap()
          .then((payload) => {
            const response = payload;
            let pageCount;
      
            if (!response.data || response.data.length === 0 || response.total === 0) {
              if (newPage === 0) {
                setProducts([]);
              }

              setAcceptNextPage(false);
              pageCount = 0;
              setLoadingProducts(false);
              setLoading(false);
              return;
            } else {
              pageCount = Math.ceil(response.total / response.per_page);
              if (!hasSetPriceRange && newPage === 0) {
                const minPrice = Math.round((Number(response.price_min) + Number.EPSILON) * 100) / 100;
                const maxPrice = Math.round((Number(response.price_max) + Number.EPSILON) * 100) / 100;
                disp(setBorderPrices({
                  lowerValue: minPrice,
                  greaterValue: maxPrice,
                }));

                disp(setRangeSlide({ value: maxPrice }));
                setHasSetPriceRange(true);
              }
            }

            const currentPageNumber = response.page || (newPage + 1);
            const isLastPage = currentPageNumber >= pageCount || response.data.length < response.per_page;

            if (isLastPage) {
              setAcceptNextPage(false);
            } else {
              setAcceptNextPage(true);
            }

            const productsWithWishlist = response.data.map((product) => {
              return {
                ...product,
                wishlist: wishlistData.some((item) => item.product_uuid === product.uuid),
              };
            });

            if (response.data && response.data.length > 0) {
              if (newPage === 0) {
                setProducts(productsWithWishlist);
              } else {
                setProducts(prevProducts => [...prevProducts, ...productsWithWishlist]);
              }

              if (newPage === 0) {
                const listName = productsWithWishlist[0]?.product_categories?.[0]?.category_name || id;
                trackViewItemListMarketplace({
                  itemListName: listName,
                  items: productsWithWishlist.map((p, i) => ({
                    itemId: p.uuid,
                    itemName: p.label,
                    discount: Math.max(0, (p.product_price.price_suggested || 0) - (p.product_price.price || 0)),
                    index: i,
                    itemBrand: p.brand_name || "",
                    itemCategory: p.product_categories?.[0]?.category_name || "",
                    price: p.product_price?.price || 0,
                    quantity: 1,
                  })),
                });
              }
            }

            setLoadingProducts(false);
            setLoading(false);
            setLastId(id);
          })
          .catch((err) => {
            console.log(err);
            
            if (newPage === 0) {
              setProducts([]);
            }

            setAcceptNextPage(false);
            setLoadingProducts(false);
            setLoading(false);
            notify("Erro ao tentar carregar produtos", "error");
          });
      }
    };

    fetchData();
  }, [filtersReset, id, newPage, count, cpf]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const data = await getBanner();
        setBanners(data.data || data); 
      } catch (error) {
        console.error("Erro ao buscar banners:", error);
      }
    };

    fetchBanners();
  }, []);

  if (loading) return <LoaderSmall />;

  return (
    <Container className="wl-page mt-4">
      {banners.length > 0 && (
        <Banner>
          <Carousel 
            onSlide={handleBannerView}
            onMouseDown={() => setUserInteraction(true)}
            onTouchStart={() => setUserInteraction(true)}
          >
            {banners?.map((item, index) => {
              return (
                <Carousel.Item key={`banner-${index}`}>
                  <a href={item?.uri} onClick={() => handleBannerClick(index)}>
                    <img
                      className=" w-100"
                      src={item?.s3_file}
                      alt={item?.s3_file}
                      onError={onImageError}
                    />
                  </a>
                </Carousel.Item>
              );
            })}
          </Carousel>
        </Banner>
      )}
      {showFeaturedCategories() && (
        <>
          <FeaturedCategoriesBrands>
            <p>Categorias em destaque</p>
          </FeaturedCategoriesBrands>
          <CotainerProduct>
            <Categories categoriesData={featuredCategories} />
          </CotainerProduct>
        </>
      )}

      {showFeaturedProducts() && (
        <CotainerProduct>
          <ProductsCarousel productsData={[featuredProducts]} />
        </CotainerProduct>
      )}
      <div className="mb-4 mt-0 pt-0">
        <Filter
          target={"Marcas"}
          onClickBrand={onClickBrand}
          onClickApplyFilter={onClickApplyFilter}
          onClickClearFilter={onClickClearFilter}
        />

        <Row className="mt-4">
          {(!products.length && !loading && !loadingProducts) && (
            <Container>
              <div style={{ textAlign: "center" }}>
                <h6 className="empty-favorites__title" style={{ fontSize: "24px", fontWeight: "600" }}>
                  {selectedCategoryLabel
                    ? `Não encontramos produtos em ${selectedCategoryLabel}`
                    : "Não encontramos produtos"
                  }
                </h6>
                <p className="empty-favorites__description">
                  Parece que ainda não temos nada por aqui. Mas nossa vitrine está cheia de outras opções que você pode gostar.
                </p>
              </div>
              <button
                className="btn-default-wl btn btn-primary text-xs empty-favorites__button"
                onClick={onClickClearFilter}
                type="button"
              >
                VOLTAR PARA VITRINE
              </button>
            </Container>
          )}

          {products.map((buy, index) => {
            const { uuid, label } = buy;
            const categoryName = buy.product_categories?.[0]?.category_name || id;
            const priceFormatted = {
              BRL: {
                offer: Math.round(buy?.product_price?.price) ?? 0,
                price: buy?.product_price?.price_suggested !== buy?.product_price?.price ? Math.round(buy.product_price.price_suggested) : null
              },
              points: {
                offer: Math.round(buy?.product_price?.points_suggested) ?? 0,
                price: buy?.product_price?.points !== buy?.product_price?.points_suggested ? Math.round(buy.product_price.points) : null
              },
            };

            return (
              <Col xs={6} key={uuid} className="pb-4">
                <CardProduct
                  id={uuid}
                  label={label}
                  image={buy.images[0]?.path}
                  price={priceFormatted}
                  campaign=""
                  wishlist={buy?.wishlist}
                  cashback=""
                  searchColorButton={false}
                  onProductClick={() => trackSelectItemMarketplace({
                    itemListName: categoryName,
                    itemId: buy.uuid,
                    itemName: buy.label,
                    discount: Math.max(0, (buy.product_price.price_suggested || 0) - (buy.product_price.price || 0)),
                    index: index,
                    itemBrand: buy.brand_name || "",
                    itemCategory: buy.product_categories?.[0]?.category_name || "",
                    price: buy.product_price?.price || 0,
                    quantity: 1,
                  })}
                  onAddToWishlist={() => trackAddToWishlistMarketplace({
                    itemListName: categoryName,
                    itemId: buy.uuid,
                    itemName: buy.label,
                    discount: Math.max(0, (buy.product_price.price_suggested || 0) - (buy.product_price.price || 0)),
                    index: index,
                    itemBrand: buy.brand_name || "",
                    itemCategory: buy.product_categories?.[0]?.category_name || "",
                    price: buy.product_price?.price || 0,
                    quantity: 1,
                  })}
                />
              </Col>
            );
          })}

          {products && acceptNextPage && (
            <UIInfiniteScroll fetchMore={() => fetchMore()} />
          )}
        </Row>
      </div>
      {loadingProducts && (
        <div className="text-center mb-5">
          <span className="spinner-border color-wl" role="status" />
        </div>
      )}
    </Container>
  );
}
